<template>
  <div>
    <div>
      <div class="vuse-content-wrapper" v-if="!loading">
        <v-col>
          <h2 class="ml-3" v-text="$t(page+'.Settings')"></h2>
        </v-col>
        <v-container fluid>
          <v-tabs
            background-color="orange"
            dark
            color="success"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tabs-slider color="success"></v-tabs-slider>
            <template v-for="t in tabs" >
              <v-tab
                :key=t.id
                :href="'#'+t.id"
              >
                {{t.name}}
              </v-tab>
              <v-tab-item :key=t.id :id="t.id">
                <v-row>
                  <v-col :md="12/t.components.length" cols="12" v-for="(c,ci) in t.components" :key="ci">
                    <v-card flat>
                      <component :is="c"></component>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
          </v-tabs>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import users from "./Partials/Users";
export default {
  components: { users },
  computed :{
      ...mapGetters(["settings"]),
  },
  data() {
    return {
      page: "Settings",
      loading:false,
      tab:null,
      tabs:[
          /*
            {"id":"sbd","name":"Slots Prenotabili","components":["slots"]},
            {"id":"tbsI","name":"Tavoli Interni Prenotabili","components":["tablesIndoor"]},
            {"id":"tbsE","name":"Tavoli Esterni Prenotabili","components":["tablesOutdoor"]},
            {"id":"tb","name":"Tavoli Attivi","components":["tablesDefault"]},
            {"id":"tbc","name":"Da Coperti a Tavoli","components":["tablesByCovers"]},*/
            {"id":"users","name":"Clienti","components":["users"]}
          ]
    };
  },
  created(){
    //this.loadData();
    /*
    if (!this.user.username){
      this.$router.push('/auth/login').catch(() => {});
    }  */
    this.user.username=JSON.parse(localStorage.getItem('user')).username;
    this.user.level=parseInt(JSON.parse(localStorage.getItem('user')).level);
    this.user.avatar=JSON.parse(localStorage.getItem('user')).avatar;    
  },
  methods:
  {
    /*async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      try{
          const res = await this.$http.post('/settings/settings_get.php', {"jwt":jwt});
          this.loading=false;
          if (res.data.errorid=='0')
          { 
            const u = res.data.user;
            console.log('u',u);
            this.$store.dispatch("setUser", res.data.user);    
            this.loading=false;
          }
          else
          {
            console.log(93,'settings.vue');
          }      
      } catch(e)
      {
        //this.$router.go();
      }
      //this.loading=false;
    },*/
  }
};
</script>
